import { render, staticRenderFns } from "./AccessResourceTree.vue?vue&type=template&id=0e7c2b94&"
import script from "./AccessResourceTree.vue?vue&type=script&lang=ts&"
export * from "./AccessResourceTree.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports